import React from 'react';
import { tokens } from '@facet-wealth/design';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('LightPaper', (theme) => ({
  root: {
    backgroundColor: tokens.color_oceana_50,
    borderRadius: theme.spacing(2),
  },
}));

// This is a temporary component that we are using for this one-off case while we figure out the right way to bring
// this into the design system. It should not be used more broadly than this.
export const LightPaper = ({ children, padding }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div
      className={classes.root}
      style={{
        padding: theme.spacing(padding),
      }}
    >
      {children}
    </div>);
};

LightPaper.defaultProps = {
  padding: 0,
};

LightPaper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  padding: PropTypes.number,
};
